export const onEnterPress = (
  keypress: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
  cb: () => void
) => {
  if (keypress.key === "Enter") {
    cb();
  }
};
